import { IGetS3ServicesResponse } from '../../types/meta';
import { axiosInstance } from '../axiosInstance';

export const getS3Services = async (): Promise<IGetS3ServicesResponse> => {
  const response = await axiosInstance.get(`/s3/services`);

  return response.data;
};
